var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6 text-left" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-danger",
            attrs: { disabled: !_vm.canWrite },
            on: {
              click: function($event) {
                return _vm.$emit("delete")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-trash-o" }),
            _vm._v(" " + _vm._s(_vm.deleteButtonText) + "\n            ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-danger mr-3",
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [
            _c("i", { staticClass: "fas fa-backspace mr-1" }),
            _vm._v(
              " " + _vm._s(_vm.resource("Button_Cancel")) + "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-success",
            class: { disabled: _vm.invalid },
            attrs: { disabled: !_vm.canWrite },
            on: {
              click: function($event) {
                return _vm.$emit("save")
              }
            }
          },
          [
            _c("i", { staticClass: "far fa-save mr-1" }),
            _vm._v(" " + _vm._s(_vm.resource("Button_Save")) + "\n            ")
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }